// User Module vuex
//import { apolloClient } from '@/apollo'

// Graph
//import { GetUser, GetWorkers, GetIssues, GetPremium } from '@/graphql/user'

// Routes
//import router from '@/router'

import axios from 'axios'

// Hooks
import dataValidates from '@/hooks/dataValidates'
import dataClone from '@/hooks/dataClone'
import dataSet from '@/hooks/dataSet'
import promoData from '@/data/promoData'

// State Module
const state = {
    item: null,
    items: [],
    data: promoData,
    remove: null,
    loader: false,
    page: 1,
    total: null
}

// Getters Module
const getters = {
    validData: state => {
        let valid = true
        Object.keys(state.data).forEach(key => {
            let item = state.data[key];
            if ((item.validate || item.required) && (item.error !== '' || item.error === null)) {
                valid = false
            }
        })
        return valid
    }
}

// Actions Module
const actions = {

    // Set Items Action
    setItems({commit}, page) {
        commit('setLoader', true)

        // initialize page string for first
        // at first call page variable is 1 (starting page)
        // then page variable takes the value of every page pressed by user
        // in pagination component
        const pageStr = `?page=${page || 1}`
        axios.get('/promocode/get-custom/list' + pageStr).then(({data}) => {
            if (data && (data.entities)) {
                commit('setItems', data.entities.map(item => {
                    return {
                        id: item._id,
                        code: item.code,
                        discount: item.discount,
                        type: item.type,
                        date: item.date,
                        counter: item.counter
                    }
                }))
                commit('setTotal', data.total_count);
                //if (state.total > 0 && (state.total < state.page)) {
                //commit('setPage', (state.page - 1) > 1 ? state.page - 1 : 1)
                //dispatch('setItems')
                //}
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            commit('setLoader', false)
        })
    },

    // Set Items Custom Action
    setItemsCustom({commit}, page) {
        commit('setLoader', true)

        // initialize page string for first
        // at first call page variable is 1 (starting page)
        // then page variable takes the value of every page pressed by user
        // in pagination component
        const pageStr = `?page=${page || 1}`
        axios.get('/promocode/get-auto-generated/list' + pageStr).then(({data}) => {
            if (data && (data.entities)) {
                commit('setItems', data.entities.map(item => {
                    return {
                        id: item._id,
                        code: item.code,
                        discount: item.discount,
                        type: item.type,
                        date: item.date,
                        counter: item.counter
                    }
                }))
                commit('setTotal', data.total_count);
                //if (state.total > 0 && (state.total < state.page)) {
                //commit('setPage', (state.page - 1) > 1 ? state.page - 1 : 1)
                //dispatch('setItems')
                //}
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            commit('setLoader', false)
        })
    },

    // Set Item Action
    setItem({commit}, value) {
        commit('setData', dataSet(state.data, value))
        commit('setItem', value)
        commit('setRemove', null)
    },

    // Set New Item Action
    setNewPromo({state, commit}) {
        commit('setData', dataSet(state.data, null))
        commit('setItem', dataClone(state.data, {id: null}, true))
        commit('setRemove', null)
    },

    // Set Data Action
    setData({state, commit}, value) {
        commit('setData', dataValidates(state.data, value))
    },

    // Set Page
    setPage({dispatch, commit}, value) {
        // set page to store current page that user pressed
        // values passed from setpage emit
        // value.page -> current page
        // value.dispatchFn -> function to dispatch
        commit('setPage', value.page)
        if (value.dispatchFn) {
            dispatch(value.dispatchFn, value.page)
        }
    },

    // Save Function Action
    saveFunction({dispatch, state, commit}) {
        commit('setLoader', true)
        const params = {
            code: state.data.code.value || null,
            discount: state.data.discount.value || null,
            type: state.data.type.value ? state.data.type.value.value : null,
            date: state.data.date.value || null
        }
        if (state.item.id) {
            params.id = state.item.id
        }
        axios.post(params.id ? '/promocode/update' : '/promocode/create', params).then().catch(error => {
            console.log(error)
        }).finally(() => {
            commit('setData', dataSet(state.data, null))
            commit('setItem', null)
            dispatch('setItems')
        })
    },

    // Set Remove Action
    setRemove({commit}, value) {
        commit('setData', dataSet(state.data, null))
        commit('setItem', null)
        commit('setRemove', value)
    },

    // Remove Function Action
    removeFunction({dispatch, state, commit}) {
        if (state.remove) {
            commit('setLoader', true)
            axios.post('/promocode/delete', {id: state.remove.id}).then().catch(error => {
                console.log(error)
            }).finally(() => {
                commit('setRemove', null)
                dispatch('setItems')
            })
        }
    }

}

// Mutations Module
const mutations = {

    // Set Items Mutation
    setItems(state, value) {
        state.items = value
    },

    // Set Total Mutation
    setTotal(state, value) {
        state.total = value
    },

    // Set Page Mutation
    setPage(state, value) {
        state.page = value
    },

    // Set Item Mutation
    setItem(state, value) {
        state.item = value
    },

    // Set Data Mutation
    setData(state, value) {
        state.data = value
    },

    // Set Item Mutation
    setRemove(state, value) {
        state.remove = value
    },

    // Set Loader File Mutation
    setLoader(state, value) {
        state.loader = value
    }

}

// Export Module
export default {
    root: true,
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
